import { __decorate } from "tslib";
import AppSegmentations from '@/components/v2/AppSegmentations';
import AppBasicDetails from '@/components/v2/AppBasicDetails';
import ActionButton from '@/components/action_button/Index.vue';
import BaseTrialPlanCard from '@/components/v2/BaseTrialPlanCard.vue';
import BaseSubtitle from '@/components/v2/BaseSubtitle';
import CustomerSegmentationForm from '@/components/v2/CustomerSegmentationForm.vue';
import CustomerSegmentationMixin from '@/helpers/vue_mixins/v2/CustomerSegmentationMixin';
import PageTitle from '@/components/v2/PageTitle.vue';
import PaginatorMixin from '@/helpers/vue_mixins/v2/PaginatorMixin';
import Paginator from '@/components/v2/Paginator.vue';
import OrderDetailsMixin from '@/helpers/vue_mixins/v2/ecommerce/OrderDetailsMixin';
import RequestDetailsMixin from '@/helpers/vue_mixins/v2/inquiry/RequestDetailsMixin';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import { Bundle } from '@/helpers/entities/enums/v2/Bundle';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import Avatar from '@/components/avatar/Index.vue';
import CustomerSegmentExportManager from '@/components/v2/CustomerSegmentExportManager.vue';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
let Customers = class Customers extends mixins(mixins(CustomerSegmentationMixin, OrderDetailsMixin, RequestDetailsMixin, PaginatorMixin, ViewportSizeMixin), CleverTapEventsMixin) {
    constructor() {
        super(...arguments);
        this.orderDetails = false;
    }
    get bundleSideNavTemplate() {
        // Dynamically Import Component
        // https://twitter.com/DamianDulisz/status/903569400095285248/photo/1
        return () => import(`@/components/v2/side_nav/${this.bundle}.vue`);
    }
    get currentRoute() {
        return this.$router.currentRoute;
    }
    get bundle() {
        const { key } = this.currentRoute.params;
        return key;
    }
    get segmentationTemplate() {
        const { bundle } = this;
        switch (bundle) {
            case Bundle.Ecommerce:
                return () => import('@/components/v2/ecommerce/CustomersBySegment');
            case Bundle.Inquiry:
                return () => import('@/components/v2/inquiry/CustomersBySegment');
            default:
                return () => import('@/components/v2/ecommerce/CustomersBySegment');
        }
    }
    get customerCardTemplate() {
        const { bundle } = this;
        switch (bundle) {
            case Bundle.Ecommerce:
                return () => import('@/components/v2/CustomerCard.vue');
            case Bundle.Inquiry:
                return () => import('@/components/v2/inquiry/CustomerCard.vue');
            default:
                return () => import('@/components/v2/CustomerCard.vue');
        }
    }
    get customerCardDialogTemplate() {
        const { bundle } = this;
        switch (bundle) {
            case Bundle.Ecommerce:
                return () => import('@/components/v2/ecommerce/TheOrderDetailsDialog.vue');
            case Bundle.Inquiry:
                return () => import('@/components/v2/inquiry/TheRequestDetailsDialog.vue');
            default:
                return () => import('@/components/v2/ecommerce/TheOrderDetailsDialog.vue');
        }
    }
    mounted() {
        this.viewCustomerSegmentPage();
    }
};
Customers = __decorate([
    Component({
        components: {
            AppSegmentations,
            AppBasicDetails,
            ActionButton,
            BaseSubtitle,
            BaseTrialPlanCard,
            CustomerSegmentationForm,
            PageTitle,
            Paginator,
            Avatar,
            CustomerSegmentExportManager,
        },
    })
], Customers);
export default Customers;
